import {
  GET_ALL_BANNERS,
  ADD_NEW_BANNER,
  REMOVE_SINGLE_BANNER,
  BANNERS_CURRENT_PAGE,
  BANNERS_TOTAL_PAGES,
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  allBanners: [],
  bannerTotalPages: 0,
  bannerCurrentPage: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALL_BANNERS: {
      return {
        ...state,
        allBanners: action.payload,
      };
    }
    case ADD_NEW_BANNER: {
      return {
        ...state,
        allBanners: [action.payload, ...state.allBanners],
      };
    }
    case BANNERS_CURRENT_PAGE: {
      return {
        ...state,
        bannerCurrentPage: action.payload,
      };
    }
    case BANNERS_TOTAL_PAGES: {
      return {
        ...state,
        bannerTotalPages: action.payload,
      };
    }
    case REMOVE_SINGLE_BANNER: {
      return {
        ...state,
        allBanners: state.allBanners.filter(
          (item) => (item._id || item.id) !== action.payload
        ),
      };
    }

    default:
      return state;
  }
};
